module.exports = __webpack_public_path__ + "img/expired.6c2ae3af.png";